<template>
  <section v-loading="loading">
    <el-form :inline="true" @submit.native.prevent label-width="130px" style="margin-bottom: 20px">
      <el-form-item label="SpuIds:">
        <el-input v-model="SpuIds" placeholder="请输入商品Id"></el-input>
      </el-form-item>
      <el-form-item label="商品名称:">
        <el-input v-model="proName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="型号:">
        <el-input v-model="modelCode" placeholder="请输入型号"></el-input>
      </el-form-item>
      <el-form-item label="分销商:">
        <el-select v-model="resellerName" filterable remote :remote-method="remoteReseller" placeholder="分销商"
          value-key="id" @change="changeReseller">
          <el-option v-for="(item, index) in resellerList" :key="index" :label="item.value" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型：">
        <el-cascader clearable @change="changeCascader" v-model="TypeIds" ref="typeCascader"
          :props="{ value: 'id', label: 'typeName', children: 'childrens', checkStrictly: true, }"
          :show-all-levels="false" :options="productNavTypeTreeList" placeholder="请选择类型"></el-cascader>
      </el-form-item>
      <el-form-item label="品牌：">
        <el-autocomplete class="w100" v-model="brandName" :fetch-suggestions="queryBrandAsync" placeholder="商品品牌"
          @select="handleBrand" clearable @clear="clearBrandBtn"></el-autocomplete>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"></el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left: 40px">
        <el-button type="primary" @click="searchFun">查询</el-button>
        <el-button type="danger" @click="resetFun">重置</el-button>
      </el-form-item>
    </el-form>
    <!--工具条-->
    <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
    <div>
      <!-- <el-button type="primary" @click="exportBtn">导出</el-button> -->
      <el-button type="primary" @click="addBtn">添加</el-button>
      <el-button type="primary" @click="batchOnShelves">批量上架</el-button>
    </div>
    <!--列表-->
    <el-card>
      <el-table :data="specs" highlight-current-row v-loading="listLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
        @cell-dblclick="cellClick" @selection-change="selectCurrentRow" border>
        <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
        <el-table-column prop="id" label="SpuId" width="70" align="center"></el-table-column>
        <el-table-column label="Sku信息" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-for="(item, index) in scope.row.skulist" :key="index"
              @click="copeData(scope.row)">{{
                item.id }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="70" align="center">
          <template slot-scope="scope">
            <el-input v-show="scope.row.isSort" v-model="scope.row.sort"
              @change="changeSort(scope.$index, scope.row)"></el-input>
            <span v-show="!scope.row.isSort" style="color: #409EFF">{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="库存" width="150" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.skulist && scope.row.skulist.length === 1">
              <el-input v-model="scope.row.spuStock" style="width: 100%;"></el-input>
              <el-button type="text" @click="handleSaveStockRow(scope.row)">保存</el-button>
            </div>
            <el-button size="small" type="primary" @click="handleUpdateSpuStocks(scope.row)">区域库存</el-button>
          </template>
        </el-table-column>
        <el-table-column label="B端主图" width="150" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.skuPicUrlB" width="120" alt="暂无" @click="handleLookBigPic(scope.row.skuPicUrlB)" />
          </template>
        </el-table-column>
        <el-table-column label="C端主图" width="150" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.skuPicUrlC" width="120" alt="暂无" @click="handleLookBigPic(scope.row.skuPicUrlC)" />
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.supplierShelvesAuditStatus == 1">待审核</span>
            <span v-if="scope.row.supplierShelvesAuditStatus == 3">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="proName" label="商品名称" align="center" width="400"></el-table-column>
        <el-table-column prop="modelCode" label="型号" width="200" align="center"></el-table-column>
        <el-table-column prop="typeName" label="类型" width="80" align="center"></el-table-column>
        <el-table-column prop="brandName" label="品牌" width="80" align="center"></el-table-column>
        <el-table-column label="供货价" width="80" align="center">
          <template slot-scope="scope">
            <p style="border-bottom: 1px solid #EBEEF5;" v-for="(v, i) in scope.row.skulist" :key="i">￥{{ v.billPrice }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="商家价格" width="120" align="center" v-if="priceType ===2">
          <template slot-scope="scope">
            <p style="border-bottom: 1px solid #EBEEF5;" v-for="(v, i) in scope.row.skulist" :key="i">￥{{
              v.merchantPrice
            }}</p>
          </template>
        </el-table-column>
        <el-table-column label="零售价格" width="120" align="center" v-if="priceType ===2">
          <template slot-scope="scope">
            <p style="border-bottom: 1px solid #EBEEF5;" v-for="(v, i) in scope.row.skulist" :key="i">￥{{
              v.customerPrice
            }}</p>
          </template>
        </el-table-column>
        <el-table-column label="市场价" width="120" align="center" v-if="priceType ===2">
          <template slot-scope="scope">
            <p style="border-bottom: 1px solid #EBEEF5;" v-for="(v, i) in scope.row.skulist" :key="i">￥{{ v.marketPrice
              }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="supName" label="供应商" width="200" align="center"></el-table-column>
        <!-- <el-table-column prop="spuStock" label="库存" width="200" align="center"></el-table-column>
        <el-table-column label="销量(基数/实际/总)" width="200" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.salesSeed}}/{{scope.row.salesActual}}/{{scope.row.salesTotal}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="seriesName" label="相关系列" align="center" width="200"></el-table-column> -->
        <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
        <el-table-column prop="lastSaleOrderTime" label="最后动销时间" width="200" align="center"></el-table-column>
        <el-table-column width="250" label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="warning" v-if="isShowShelves"
              @click="handleOnShelves(scope.row)">上架</el-button>
            <el-button size="small" type="primary" v-if="isShowEdit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="success" v-if="isShowDel" @click="handleDel(scope.row)">删除</el-button>
            <el-button size="small" type="success" v-if="isShowCopy" @click="handleCopy(scope.row)">复制</el-button>
            <el-button v-if="isShowEditPrice && !scope.row.isPriceLock" size="small" type="danger"
              style="margin-left: 10px" @click="copeData(scope.row)">修改价格</el-button>
            <el-button size="small" type="primary" @click="handleUpdatePrice(scope.row)">修改价格</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"
        style="float: right"></el-pagination>
    </el-card>
    <el-dialog width="50%" :visible.sync="isShowBigPic">
      <img :src="bigPic" style="width: 100%; height:100%;">
    </el-dialog>
    <el-dialog @close="closeCopy" title="复制商品" :visible.sync="codeDialogVisible" width="30%">
      <el-form>
        <el-form-item>
          <el-checkbox v-model="isCopyCode">是否复制编码</el-checkbox>
        </el-form-item>
        <el-form-item label="供应商">
          <el-autocomplete v-model="copyData.supName" :fetch-suggestions="querySearchAsync" placeholder="请输入供应商"
            @select="handleSelect"></el-autocomplete>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCopy">取 消</el-button>
        <el-button type="primary" @click="confirmCopy">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改价格 -->
    <el-dialog title="修改价格" width="50%" :visible.sync="popoverVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div>
        <el-table :data="scopeRow" v-if="scopeRow[0]" border>
          <el-table-column align="center" label="商家价">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.merchantPrice" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="零售价">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.customerPrice" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市场价">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.marketPrice" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="采购价">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.billPrice" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="下单返豆">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.orderRebate" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="台返">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.unitRebate" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="月返">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.monthRebate" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="结构返利">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.structRebate" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="补贴">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.subsidy" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="高采后返">
            <template slot-scope="cscope">
              <el-input v-model="cscope.row.highPurchaseAfterRebate" style="width: 80px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="cscope">
              <el-button size="small" type="primary" v-if="isShowShelves" @click="handleEditPrice(cscope.row)">确定
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="修改价格" :visible.sync="priceVisible" width="60%" :before-close="priceClose" v-loading="loading">
      <el-table :data="row.skulist" style="width: 100%" border :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="id" label="skuId"></el-table-column>
        <el-table-column label="供货价">
          <template slot-scope="scope">
            <el-input v-model="scope.row.billPrice" style="width: 100%;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="商家价格" v-if="priceType !== 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.merchantPrice" style="width: 100%;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="零售价格" v-if="priceType !== 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerPrice" style="width: 100%;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="市场价" v-if="priceType !== 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.marketPrice" style="width: 100%;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleSavePrice(scope.row)">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="priceClose">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改库存" :visible.sync="updateSpuStockVisible" width="60%" :before-close="updateSpuStockClose"
      v-loading="loading">
      <el-table :data="row.skulist" style="width: 100%" border :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="id" label="skuId"></el-table-column>
        <el-table-column label="库存数">
          <template slot-scope="scope">
            <el-input v-model="scope.row.defaultStock" style="width: 100%;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleSaveStock(scope.row)">保存</el-button>
            <el-button type="text" size="small" @click="setRegStock(scope.$index)">区域库存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="updateSpuStockClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 区域库存设置 -->
    <el-dialog title="区域库存设置" :visible.sync="regStockVisible" :close-on-click-modal="false" v-loading="loading">
      <regstock v-model="goodDetailForm" :areaStockIndex="areaStockIndex" :regStockSkuId="regStockSkuId"
        :isSingleSpec="goodDetailForm.isSingleSpec" ref="regstock" v-if="regStockVisible"></regstock>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="regStockVisible = false">取消</el-button>
        <el-button type="primary" @click.native="setAreaShowSubmit">提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  KSAXApiRequest,
  GetAllReseller,

  productNavTypeTree,
  getBrandListPage,
  busSupplierList,
  getSpuOffSaleListPage,
  updateIsShelves,
  batchUpdateIsShelves,
  updateIsDeleted,
  batchUpdateIsDeleted,
  proCopy,
  updateSpuPrice,
  Product_SpuUpdateSpuSort,
  ExportOffSaleList, areaList,
  GetApprovalAfterPrice
} from "../../api/api";
import regstock from "./components/Regstock";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import autocomplete from "../../components/autocomplete";

export default {
  components: { Toolbar, autocomplete, regstock },
  data() {
    return {
      loading: false,
      ResellerId: 0,
      resellerName: null,
      priceType: 0,
      supType: 0,
      resellerList: [],
      brandList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      province: '',
      AdvantageAreaProvinceId: null,
      city: '',
      AdvantageAreaCityId: null,
      district: '',
      AdvantageAreaDistrictId: null,
      copyRow: null,
      isCopyCode: true,
      codeDialogVisible: false,
      SpuIds: null,
      proName: null, //商品名称
      modelCode: null, //商品型号
      SupId: null, //供应商
      TypeId: null,
      TypeIds: [], //商品类型
      BrandId: null, //品牌
      brandName: null,
      CreateTime_Start: null,
      CreateTime_End: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      productNavTypeTreeList: [],
      inputValue: "",
      valueTime: null,
      IsShowPosition: 3,

      buttonList_toolBar: [],
      specs: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: [],

      isShowShelves: true,
      isShowEdit: true,
      isShowCopy: false,
      isShowEditPrice: false,
      isShowDel: false,
      scopeRow: [],

      brandmodelData: {
        name: "",
        restaurants: [],
      },
      supmodelData: {
        name: "",
        restaurants: [],
      },
      isShowBigPic: false,
      bigPic: null,
      SalesActual: null,
      SalesSeed: null,
      SalesTotal: null,
      popoverVisible: false,
      approvalAfterPrice: null,
      supplierList: [],
      copyData: {
        supName: null,
        supId: null,
      },
      priceVisible: false,
      row: [],
      row: [],
      updateSpuStockVisible: false,
      regStockVisible: false,
      regStockSkuId: 0,
      areaStockIndex: 0,
      goodDetailForm: {},
    };
  },
  created() {
    this.getProductNavTypeTree();
    this.getBrandList();
    // this.getBusSupplierList();
    // this.getProvinceList();
  },

  mounted() {
    this.getResellerId();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.log('routers', routers)
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    buttonList.forEach((v) => {
      if (v.Func == "handleOnShelves") {
        this.isShowShelves = true;
      } else if (v.Func == "handleEdit") {
        this.isShowEdit = true;
      } else if (v.Func == "handleCopy") {
        this.isShowCopy = true;
      } else if (v.Func == "handleEditPrice") {
        this.isShowEditPrice = true;
      } else if (v.Func == "handleDel") {
        this.isShowDel = true;
      }
    });
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.ButtonType === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
    }
  },
  methods: {
    getResellerId() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.ResellerId = res.data.result.items[0].remoteKey
          this.resellerName = res.data.result.items[0].name
          this.priceType = res.data.result.items[0].priceType
          this.supType = res.data.result.items[0].supType;
          this.resellerList = res.data.result.items.map((item) => {
            return {
              value: item.name,
              id: item.remoteKey,
              supType: item.supType,
              priceType: item.priceType,
            };
          });
          this.getSpusOffSale();
        }
      })
    },
    getBrandList(key) {
      let obj = {
        path: 'Product_Brand/list',
        parmsJson: {
          SkipCount: 0,
          MaxResultCount: 100,
        }
      };
      if (key) {
        obj.parmsJson.name = key;
      }
      return new Promise((resolve, reject) => {
        KSAXApiRequest(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.response.data.map((item) => {
              return {
                value: item.brandName,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async queryBrandAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleBrand(item) {
      this.BrandId = item.id;
    },
    clearBrandBtn(val) {
      this.BrandId = null
    },
    getProductNavTypeTree() {
      let that = this;
      let data = {
        path: 'Product_Type/TreeList'
      }
      KSAXApiRequest(data).then((res) => {
        that.productNavTypeTreeList = res.data.response;
      });
    },
    changeReseller(val) {
      this.ResellerId = val.id
      this.resellerName = val.value
      this.priceType = val.priceType
      this.supType = val.supType;
    },
    remoteReseller(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        GetAllReseller(obj).then((res) => {
          this.isShowPage = true;
          // console.log('供应商列表', res);
          if (res.data.success) {
            this.resellerList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
                supType: item.supType,
                priceType: item.priceType,
              };
            });
            // console.log('this.supplierList', this.supplierList)
            resolve(this.resellerList);
          } else {
            this.isShowPage = true;
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.fetchSupplierList(queryString);
        cb(res);
      } else {
        let res = await this.fetchSupplierList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.copyData.supId = item.id;
    },
    fetchSupplierList(key) {
      let obj = {
        pageIndex: 1,
        pageSize: 100,
      };
      if (key) {
        obj.supName = key;
      }
      return new Promise((resolve, reject) => {
        busSupplierList(obj).then((res) => {
          if (res.data.success) {
            this.supplierList = res.data.response.data.map((item) => {
              return {
                value: item.SupName,
                id: item.Id,
              };
            });
            resolve(this.supplierList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    changeCascader(val) {
      let obj = this.$refs['typeCascader'].getCheckedNodes();
      console.log(obj)
      if (obj.length > 0) {
        //选中
        this.TypeId = obj[0].value
      } else {
        //清空
        this.TypeId = null
      }
    },
    cancelCopy() {
      console.log('cancel')
      this.codeDialogVisible = false
      this.isCopyCode = true
      this.copyRow = null
    },
    closeCopy() {
      console.log('cancel')
      this.codeDialogVisible = false
      this.isCopyCode = true
      this.copyRow = null
    },
    confirmCopy() {
      let that = this;
      let params = {
        spuId: this.copyRow.Id,
        isCopyCode: this.isCopyCode,
        supId: this.copyData.supId
      };
      // let Str = this.isCopyCode ? '带编码' : '不带编码'
      // that
      //     .$confirm(`确认${Str}复制该商品吗?`, "提示", {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       closeOnClickModal: false,
      //       type: "warning",
      //     })
      //     .then(() => {
      proCopy(params).then((res) => {
        if (res.data.success) {
          that.$message.success(res.data.msg);
          this.getSpusOffSale();
          this.codeDialogVisible = false
          this.isCopyCode = true
          this.copyRow = null
        } else {
          that.$message.error(res.data.msg);
        }
      });
      // });
    },
    //获取供应商列表
    getBusSupplierList(e) {
      let that = this;
      let params = {
        supName: e ? e : "",
        pageIndex: 1,
        pageSize: 100,
      };
      busSupplierList(params).then((res) => {
        let list = [];
        res.data.response.data.forEach((v, i) => {
          list[i] = {
            value: v.SupName,
            id: v.Id,
          };
        });
        that.supmodelData.restaurants = list;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func](this, item);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getSpusOffSale();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.getSpusOffSale();
    },
    handleLookBigPic(url) {
      if (!url) return this.$message.error('暂无图片');
      this.bigPic = url;
      this.isShowBigPic = true;
    },
    //获取规格列表
    getSpusOffSale() {
      let that = this;
      let para = {
        SpuIds: that.SpuIds,
        proName: that.proName, //商品名称
        modelCode: that.modelCode, //商品型号
        SupId: that.ResellerId, //供应商
        TypeId: that.TypeId, //商品类型
        BrandId: that.BrandId, //品牌
        CreateTime_Start: that.CreateTime_Start,
        CreateTime_End: that.CreateTime_End,
        PageIndex: that.PageIndex,
        PageSize: that.PageSize,
      };
      para.AdvantageAreaProvinceId = this.AdvantageAreaProvinceId;
      para.AdvantageAreaCityId = this.AdvantageAreaCityId;
      para.AdvantageAreaDistrictId = this.AdvantageAreaDistrictId;
      let data = {
        "path": "Product_Spu/offsalelist",
        "parms": "",
        "parmsJson": para
      }
      this.listLoading = true;
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          if (res.data.response.data) {
            res.data.response.data.forEach(item => {
              item.isSort = false
            })
          }
          this.total = res.data.response.dataCount;
          this.specs = res.data.response.data;
          this.listLoading = false;
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    searchFun() {
      this.PageIndex = 1;
      this.getSpusOffSale();
    },
    handlePicker(e) {
      this.CreateTime_Start = e[0];
      this.CreateTime_End = e[1];
    },
    resetFun() {
      this.SpuIds = null;
      this.TypeIds = null;
      this.proName = null; //商品名称
      this.modelCode = null; //商品型号
      this.SupId = null; //供应商
      this.TypeId = null
      this.BrandId = null; //品牌
      this.brandName = null
      this.CreateTime_Start = null;
      this.CreateTime_End = null;
      this.PageIndex = 1; //页码
      this.PageSize = 10; //页长
      this.supmodelData.name = null;
      this.brandmodelData.name = null;
      this.province = '';
      this.city = '';
      this.district = '';
      this.AdvantageAreaProvinceId = null;
      this.AdvantageAreaCityId = null;
      this.AdvantageAreaDistrictId = null;
      this.getSpusOffSale();
    },
    handleSupInput(e) {
      this.getBusSupplierList(e);
    },
    handleSupSelect(e) {
      this.SupId = e.id;
    },
    handleCopy(row) {
      this.codeDialogVisible = true;
      this.copyRow = row
      this.copyData = {
        supId: null,
        supName: null
      }
      // let that = this;
      // let params = {
      //   spuId: row.Id,
      // };
      // that
      //   .$confirm("确认复制该商品吗?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     closeOnClickModal: false,
      //     type: "warning",
      //   })
      //   .then(() => {
      //     proCopy(params).then((res) => {
      //       if (res.data.success) {
      //         that.$message.success(res.data.msg);
      //         that.getSpusOffSale();
      //       } else {
      //         that.$message.error(res.data.msg);
      //       }
      //     });
      //   });
    },
    async handleOnShelves(row) {
      let that = this;
      let params = {
        path: 'Product_Spu/UpdateIsShelves',
        parmsJson: {
          spuId: row.id,
          isShelves: true,
        }
      };
      that
        .$confirm("确认上架该商品吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          KSAXApiRequest(params).then((res) => {
            that.$message.success(res.data.msg);
            that.getSpusOffSale();
          });
        });
    },
    handleDel(row) {
      let that = this;
      let params = {
        spuId: row.Id,
        isDeleted: true,
      };
      that
        .$confirm("确认删除该商品吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          updateIsDeleted(params).then((res) => {
            that.$message.success(res.data.msg);
            that.getSpusOffSale();
          });
        });
    },
    batchOnShelves() {
      let that = this;
      if (that.currentRow[0]) {
        that
          .$confirm("确认上架这些商品吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            let list = [];
            that.currentRow.forEach((v, i) => {
              list.push(v.id);
            });
            let params = {
              path: 'Product_Spu/BatchUpdateIsShelves',
              parmsJson: {
                supId: that.ResellerId,
                spuIds: list,
                isShelves: true,
              }
            };
            KSAXApiRequest(params).then((res) => {
              that.$message.success(res.data.msg);
              that.getSpusOffSale();
            });
          });
      } else {
        that.$message.error("请选择需要批量上架的商品");
      }
    },
    batchDelete() {
      let that = this;
      if (that.currentRow[0]) {
        that
          .$confirm("确认删除这些商品吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            let list = [];
            that.currentRow.forEach((v, i) => {
              list.push(v.Id);
            });
            let params = {
              spuIds: list,
              isDeleted: true,
            };
            batchUpdateIsDeleted(params).then((res) => {
              that.$message.success(res.data.msg);
              that.getSpusOffSale();
            });
          });
      } else {
        that.$message.error("请选择需要批量删除的商品");
      }
    },
    exportBtn() {
      let that = this;
      let para = {
        path: 'Product_Spu/ExportOffSaleList',
        parms: '',
        parmsJson: {
          SpuIds: that.SpuIds,
          proName: that.proName, //商品名称
          modelCode: that.modelCode, //商品型号
          SupId: that.ResellerId, //供应商
          TypeId: that.TypeId, //商品类型
          BrandId: that.BrandId, //品牌
          CreateTime_Start: that.CreateTime_Start,
          CreateTime_End: that.CreateTime_End,
          PageIndex: that.PageIndex,
          PageSize: that.PageSize,
        }
      };
      KSAXApiRequest(para).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请点击下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    async copeData(row) {
      // 获取商品详情
      // let data = await GetApprovalAfterPrice({ spuId: row.Id })
      // if (data.data.success) {
      //   this.approvalAfterPrice = data.data.response
      //   if (this.approvalAfterPrice) {
      //     return this.$message.error('已经发起价格审批无法修改')
      //   }
      // }
      // this.scopeRow = []
      // if (row.IsTieredPricing) {
      //   this.$confirm(
      //     "该商品存在阶梯价格，若有需要请记得手动修改阶梯价格。",
      //     "提示",
      //     {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //     }
      //   )
      //     .then(() => {
      //       this.popoverVisible = true;
      //       this.scopeRow = row.skulist
      //     })
      //     .catch(() => {
      //       this.popoverVisible = false;
      //     });
      // } else {
      //   this.scopeRow = row.skulist
      //   this.popoverVisible = true;
      // }
    },
    addBtn() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    handleEdit(row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
      // let { href } = this.$router.resolve({ path: `/Product/AddEditSpu?id=${row.id}` })
      // window.open(href, '_blank')
    },
    handleEditPrice(row) {
      let that = this;
      if (Number(row.MerchantPrice) > Number(row.CustomerPrice))
        return that.$message.error("商家价要小于C端价");
      if (Number(row.CustomerPrice) > Number(row.MarketPrice))
        return that.$message.error("C端价要小于市场价");
      let params = {
        spuId: row.SpuId,
        skuId: row.Id,
        merchantPrice: row.MerchantPrice,
        customerPrice: row.CustomerPrice,
        marketPrice: row.MarketPrice,
        billPrice: row.BillPrice ? row.BillPrice : 0,
        orderRebate: row.OrderRebate,
        unitRebate: row.UnitRebate,
        monthRebate: row.MonthRebate,
        structRebate: row.StructRebate,
        subsidy: row.Subsidy,
        highPurchaseAfterRebate: row.HighPurchaseAfterRebate
      };
      that
        .$confirm("确认修改该商品的价格吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          updateSpuPrice(params).then((res) => {
            if (res.data.success) {
              that.$message.success(res.data.msg);
              this.popoverVisible = false
              that.getSpusOffSale();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    cellClick(row, event, column) {
      row.isSort = !row.isSort
    },
    changeSort(index, row) {
      // let params = {
      //   spuId: row.Id,
      //   sort: row.Sort
      // }
      // Product_SpuUpdateSpuSort(params).then(res => {
      //   if (res.data.success) {
      //     this.$message.success(res.data.msg)
      //     this.getSpusOffSale()
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
    handleUpdateSpuStocks(row) {
      this.row = row;
      this.updateSpuStockVisible = true;
    },
    updateSpuStockClose() {
      this.updateSpuStockVisible = false;
      this.getSpusOffSale();
    },
    handleUpdatePrice(row) {
      this.row = row;
      this.priceVisible = true;
    },
    handleSavePrice(row) {
      let value = {
        supId: this.row.supId,
        skuId: row.id,
        billPrice: row.billPrice,//供货价
        merchantPrice: row.merchantPrice,//商家价格
        customerPrice: row.customerPrice,//零售价格
        marketPrice: row.marketPrice,//市场价
      }
      // priceType 1单2多
      // supType   1自2集
      if (this.priceType === 1 && this.supType === 1) {
        value = { ...value, merchantPrice: value.billPrice / 0.985 }
        value = { ...value, customerPrice: value.billPrice / 0.95 }
        value = { ...value, marketPrice: value.billPrice / 0.92 }
      }
      if (this.supType === 2) {
        value = { ...value, merchantPrice: value.billPrice }
        value = { ...value, customerPrice: value.billPrice }
        value = { ...value, marketPrice: value.billPrice }
      }
      if (this.priceType === 2 && this.supType === 1) {
        if (
          value.marketPrice > value.customerPrice &&
          value.customerPrice > value.merchantPrice &&
          value.merchantPrice > value.billPrice
        ) {

        } else {
          return this.$message.warning("市场价>零售价>商家价>采购价")
        }
      }
      let data = {
        path: "Product_Spu/UpdatePrice",
        parms: "",
        parmsJson: value,
      };
      this.loading = true
      KSAXApiRequest(data).then((res) => {
        this.loading = false
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSaveStockRow(row) {
      let value = {
        SpuId: row.id,
        SkuId: row.skulist[0].id,
        Stock: row.spuStock,
      }
      let data = {
        path: "Product_Spu/UpdateSpuStock",
        parms: "",
        parmsJson: value,
      };
      this.loading = true
      KSAXApiRequest(data).then((res) => {
        this.loading = false
        if (res.data.success) {
          this.getSpusOffSale();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSaveStock(row) {
      let value = {
        SpuId: this.row.id,
        SkuId: row.id,
        Stock: row.defaultStock,
      }
      let data = {
        path: "Product_Spu/UpdateSpuStock",
        parms: "",
        parmsJson: value,
      };
      this.loading = true
      KSAXApiRequest(data).then((res) => {
        this.loading = false
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    priceClose() {
      this.priceVisible = false;
      this.getSpusOffSale();
    },
    setRegStock(index) {
      let that = this;
      var params = {
        // spuId: that.spuId,
        "path": "Product_Spu/Detail",
        "parms": `spuId=${this.row.id}`,
        "parmsJson": null
      };
      KSAXApiRequest(params).then((res) => {
        that.goodDetailForm = res.data.response;
        this.areaStockIndex = index;
        this.regStockSkuId = this.goodDetailForm.skus[index].id;
        this.regStockVisible = true;
      })
    },
    setAreaShowSubmit() {
      this.loading = true
      this.$refs.regstock.submitAreaData();
      var params = {
        "path": "Product_Spu/UpdateSpuAreaStock",
        "parms": "",
        "parmsJson": {
          SkuId: this.goodDetailForm.skus[this.areaStockIndex].id,
          AreaStocks: this.goodDetailForm.skus[this.areaStockIndex].areaStocks,
        }
      };
      KSAXApiRequest(params).then((res) => {
        this.regStockVisible = false;
        this.loading = false
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/Product/AddEditSpu") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.el-input,
.el-select,
.el-cascader,
.el-autocomplete {
  width: 200px;
}

.el-form {
  background: #ebeef5;
  padding: 10px 10px 0 10px;
  margin-bottom: 20px;
}

section {
  padding: 20px;
}
</style>
